export default __webpack_public_path__ + "static/media/Retreat.2e757472.mp4";